import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/Button";
import { Hash } from "lucide-react";

export function PartIdCTA() {
  return (
    <section className="relative overflow-hidden bg-graphite py-20 lg:py-28 text-white" data-testid="part-id-cta">
      <div className="tech-grid-dark absolute inset-0" />
      <div className="relative mx-auto max-w-3xl px-4 sm:px-6 text-center">
        <Reveal>
          <span className="flex items-center justify-center gap-2 font-body text-xs font-semibold uppercase tracking-[0.25em] text-amber">
            <Hash className="w-4 h-4" /> Part Identification
          </span>
          <h2 className="mt-4 font-display font-bold uppercase leading-[0.95] tracking-tight text-[clamp(30px,4vw,56px)]">
            Have a Part Number?<br />Send It to Us.
          </h2>
          <p className="mt-5 mx-auto max-w-lg text-[clamp(16px,2vw,18px)] leading-relaxed text-white/70">
            Share your part number, machine model or component photo and let our team review your enquiry.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Button to="/request-a-quote" variant="accent" arrow data-testid="partid-send-btn">Send Part Details</Button>
            <Button to="/request-a-quote" variant="outline" data-testid="partid-quote-btn">Request a Quote</Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
